import React from 'react';
import Logo from '../Logo';

const Footer = () => {
  return (
    <div className="bg-neutral-900">
      <div className="px-8 pt-32 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="flex flex-col gap-3">
              <Logo width="208" height="32" />
              <p className="!text-stone-300 text-xs font-medium font-['Inter'] leading-5">
                Omnichannel AI agent platform for developers and system integrators.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <div className="text-gray-50 text-base font-bold font-['Inter']">Platform</div>
              <div className="flex flex-col gap-2">
                <a href="#features" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Capabilities</a>
                <a href="#demos" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Demos</a>
                <a href="#pricing" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Pricing</a>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <div className="text-gray-50 text-base font-bold font-['Inter']">Resources</div>
              <div className="flex flex-col gap-2">
                <a href="https://developers.remote-assistant.io" target="_blank" rel="noopener noreferrer" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors flex items-center gap-1">API Docs <i className="fa fa-external-link text-[8px] text-stone-500"></i></a>
                <a href="https://blog.remote-assistant.ai" target="_blank" rel="noopener noreferrer" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors flex items-center gap-1">Blog <i className="fa fa-external-link text-[8px] text-stone-500"></i></a>
                <a href="https://remote-assistant.ai" target="_blank" rel="noopener noreferrer" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors flex items-center gap-1">For Businesses <i className="fa fa-external-link text-[8px] text-stone-500"></i></a>
                <a href="https://status.remote-assistant.io" target="_blank" rel="noopener noreferrer" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors flex items-center gap-1">System Status <i className="fa fa-external-link text-[8px] text-stone-500"></i></a>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <div className="text-gray-50 text-base font-bold font-['Inter']">Legal</div>
              <div className="flex flex-col gap-2">
                <a href="/terms" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Terms of Service</a>
                <a href="/privacy" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Privacy Policy</a>
                <a href="/trust-and-safety" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Trust & Safety</a>
              </div>
            </div>

            {/* Security & Trust */}
            <div className="flex flex-col gap-3">
              <div className="text-gray-50 text-base font-bold font-['Inter']">Security & Trust</div>
              <div className="flex flex-wrap gap-3">
                <img src="https://img.shields.io/badge/SSL-Secured-green?style=for-the-badge&logo=lock" alt="SSL Secured" title="SSL/TLS encryption via AWS Certificate Manager" className="h-7" />
                <img src="https://img.shields.io/badge/Powered%20by-Stripe-635bff?style=for-the-badge&logo=stripe" alt="Stripe Powered" title="Secure payments powered by Stripe" className="h-7" />
                <img src="https://img.shields.io/badge/Powered%20by-AWS-orange?style=for-the-badge&logo=amazon-aws" alt="AWS Infrastructure" title="Hosted on Amazon Web Services" className="h-7" />
                <img src="https://img.shields.io/badge/PCI-Compliant-green?style=for-the-badge&logo=shield" alt="PCI Compliant" title="PCI compliance via Stripe" className="h-7" />
                <img src="https://img.shields.io/badge/SOC%202-In%20Progress-lightgrey?style=for-the-badge&logo=clipboard-check" alt="SOC 2" title="SOC 2 Type II audit underway" className="h-7 opacity-50" />
              </div>
              <p className="!text-stone-300 text-xs font-medium font-['Inter'] leading-5">
                PCI compliance via Stripe (no card data stored). SOC 2 Type II audit underway.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700 px-8 py-8">
        <div className="max-w-7xl mx-auto text-center">
          <p className="!text-stone-300 text-sm font-medium font-['Inter']">&copy; 2026 Remote Assistant. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
